import { createAsyncThunk } from '@reduxjs/toolkit';

import { endAstSignMailHandoff } from './astSignMailSlice';

import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { handleResetCall } from 'features/call/call-base/store';
import { handleError } from 'features/notification/store';

const performAstRelayTransferPlaceholder = () => {
  /*
   * TODO(AST-SIGNMAIL-RELAY-TRANSFER):
   * Replace with real AST Relay handoff implementation.
   */
};

export const completeAstSignMailHandoff = createAsyncThunk(
  'astSignMail/completeAstSignMailHandoff',
  async (_, { dispatch }) => {
    try {
      performAstRelayTransferPlaceholder();

      // TODO: This is where we will eventually need to add functionality to make sure only the
      // agent is removed from the call, not the hearing party.
      await dispatch(handleResetCall()).unwrap();
      dispatch(endAstSignMailHandoff());

      dispatch(
        sendAnalyticsInfo({
          Method: 'completeAstSignMailHandoff',
          message:
            'AST SignMail handoff completed; hearing disconnected via handleResetCall',
          LogGroup: 'AstSignMail',
        })
      );
    } catch (error) {
      dispatch(
        handleError({
          error,
          methodName: 'completeAstSignMailHandoff',
        })
      );
      throw error;
    }
  }
);
